package br.com.texeratx.boardgametimeapp.ui.screens.players.create

data class CreatePlayerState(
    val name: String = "",
    val nickname: String = "",

    // URL final (Cloudinary) que vai pro backend
    val imageUrl: String = "",

    // Preview local (KMP)
    val localImageBytes: ByteArray? = null,
    val localImageMimeType: String? = null,
    val selectedImageName: String? = null,

    val isUploadingImage: Boolean = false,

    val birthday: String = "",
    val phone: String = "",

    val isSaving: Boolean = false,
    val error: String? = null
)
